import { render, staticRenderFns } from "./ReviewReportGridComponent.vue?vue&type=template&id=79289771&scoped=true&"
import script from "./ReviewReportGridComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewReportGridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79289771",
  null
  
)

export default component.exports